import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./AdminPriceRoom.css";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createMaterials, deleteMaterials, updateMaterials } from "../../redux/addMaterialReducer";
import Swal from "sweetalert2";

function AdminPriceRoom() {
    const location = useLocation();
    const dispatch = useDispatch();
    const roomData = location.state?.roomData || [];
    const [pricemode, setPricemode] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [itemShow, setItemShow] = useState(false);
    const [unitName, setUnitName] = useState('')
    const [unit, setUnit] = useState('')





    const kitchenThingsData = useSelector((state) => state.kitchenThings?.kitchenThingsData || []);
    const bedroomThingsData = useSelector((state) => state.bedroomThings?.bedroomThingsData || []);
    const foyerThingsData = useSelector((state) => state.foyerThings?.foyerThingsData || []);
    const livingThingsData = useSelector((state) => state.livingThings?.livingThingsData || []);
    const otherWorkThingsData = useSelector((state) => state.OtherWorkThings?.otherWorkThingsData || []);
    const accessoriesThingsData = useSelector((state) => state.accessories?.accessoriesThingsData || []);
    const looseThingsData = useSelector((state) => state.looseThings?.looseThingsData || []);


    const roomType = roomData[0].table;

    const roomDatasetsMap = {
        kitchen: kitchenThingsData,
        Bedroom: bedroomThingsData,
        Foyer: foyerThingsData,
        "LivingRoom": livingThingsData,
        "OtherWorks": otherWorkThingsData,
        Accessories: accessoriesThingsData,
        "LooseFurniture": looseThingsData
    };

    const roomDatasets = roomDatasetsMap[roomType];

    console.log("roomData:", roomDatasets);




    const [addNewItem, setAddNewItem] = useState([{
        label: "", value: 0 , oldvalue: 0
    }]);
    console.log(addNewItem);



    const handleAddNewItem = () => {
        setAddNewItem([...addNewItem, { label: "", value: 0, oldvalue: 0 }]);
    };

    const handleFieldchange = (value, index, fieldName) => {
        const updatedFields = addNewItem.map((item, i) =>
            i === index ? { ...item, [fieldName]: value } : item
        );
        setAddNewItem(updatedFields);
    };

    const handleRemoveField = (index) => {
        const updatedFields = [...addNewItem];
        updatedFields.splice(index, 1);
        setAddNewItem(updatedFields);
    }

    const handelmodel = (item) => {
        console.log(item);
        setUnit(item)
        setUnitName(item.name)
        setAddNewItem(item.material)

        setModalShow(true)
    }

    const handelDeleteModel = async (item) => {
        console.log(item);
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete the item "${item.name}"? This action cannot be undone.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });
        if (!confirm.isConfirmed) return;

        try {
            await dispatch(deleteMaterials(item));
            Swal.fire(`Deleted`, `Item "${item.name}" has been deleted`, 'success');

        } catch (error) {
            console.log("Error deleting item:", error);
            Swal.fire('Error', 'There was an error deleting the item', 'error');


        }
    }


    const handleAddingRoomMaterial = () => {
        const data = unit;
        const allData = {
            id: data.id,
            material: addNewItem,
            name: unitName,
            measurement: data.measurement,
            table: data.table,
            timestamp: new Date(),
        };
        handelUpdateItem(allData)

    }

    const handelUpdateItem = async (allData) => {
        const updateData = { ...allData }; // Ensure we're working with a copy
        const roomType = updateData.table;

        console.log("Room Type:", roomType);
        console.log("Update Data:", updateData);

        const roomDataSet = {
            kitchen: kitchenThingsData,
            Bedroom: bedroomThingsData,
            Foyer: foyerThingsData,
            "LivingRoom": livingThingsData,
            OtherWorks: otherWorkThingsData,
            Accessories: accessoriesThingsData,
            "LooseFurniture": looseThingsData
        }[roomType];

        if (!roomDataSet) {
            console.error("Invalid room type:", roomType);
            return;
        }

        // Find the matching item
        const matchedItem = roomDataSet.find(item => item.id === updateData.id);

        if (!matchedItem) {
            console.warn("No matching item found in", roomType);
            return;
        }

        const updateRealValue = {
            ...matchedItem,
            material: updateData.material,
            name: updateData.name
        };
        console.log("Update Real Value:", updateRealValue);


        try {
            await dispatch(updateMaterials(updateRealValue)); // Update Firestore
            console.log("Firestore updated successfully!");
            setModalShow(false)
        } catch (error) {
            console.error("Error updating Firestore:", error);
        }
    };





    useEffect(() => {
        setPricemode("oldvalue");
    }, []);

    return (
        <div>
            <h2>{roomData[0]?.table} Room</h2>
            <hr />
            <div className="option1">
                <div className="pricemode">
                    <p
                        className={`pricemode1 ${pricemode === "oldvalue" ? "selected" : ""}`}
                        onClick={() => setPricemode("oldvalue")}
                    >
                        OLD PRICE
                    </p>
                    <p
                        className={`pricemode1 ${pricemode === "value" ? "selected" : ""}`}
                        onClick={() => setPricemode("value")}
                    >
                        NEW PRICE
                    </p>
                </div>

                <div className="adminHeader1button">
                    {/* <button onClick={() => setModalShow(true)} className="buttonDesign">
                        Add Item
                    </button> */}

                    {/* Add New Item Modal */}
                    <Modal show={modalShow} size="lg" centered>
                        <Modal.Header closeButton onClick={() => setModalShow(false)}>
                            <Modal.Title>Edit Item</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="AddNewItem">
                                <h4>Add New Item</h4>
                                <button onClick={handleAddNewItem} className="buttonDesign">
                                    Add Material
                                </button>
                            </div>
                            <hr />
                            <Form>
                                <div className="AddNewUnitName">
                                    <h6>Unit Name</h6>
                                    <input
                                        value={unitName}
                                        onChange={(e) => setUnitName(e.target.value)}
                                        className="AddNewUnitplace"
                                        type="text"
                                        placeholder="Unit Name"
                                        aria-label="Unit Name"
                                    />
                                </div>
                                <hr />
                                <div className="AddNewUnitName1">
                                    <p>Material Name</p>
                                    <p>Price</p>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '10px',
                                    paddingLeft: '50px',
                                    fontWeight: 'bold',
                                    backgroundColor: '#f8f9fa',
                                }}>
                                    <p>label name</p>
                                    <p>old price</p>
                                    <p>new price</p>
                                    <p></p>
                                </div>
                                {addNewItem.map((field, index) => (
                                    <div key={index} className="AddNewUnitName">
                                        <input
                                            className="AddNewUnitplace"
                                            type="text"
                                            onChange={(e) => handleFieldchange(e.target.value, index, 'label')}
                                            value={field.label}
                                            placeholder={`Item Name ${index + 1}`}
                                            aria-label={`Item Name ${index + 1}`}
                                        />
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            gap: 12,
                                        }} >
                                            <input
                                                type="number"
                                                className="AddNewUnitplace"
                                                value={field.oldvalue}
                                                onChange={(e) => handleFieldchange(e.target.value, index, 'oldvalue')}
                                                placeholder={`Price ${index + 1}-oldvalue`}
                                                aria-label={`Price ${index + 1}`}
                                            />
                                            <input
                                                type="number"
                                                className="AddNewUnitplace"
                                                value={field.value}
                                                onChange={(e) => handleFieldchange(e.target.value, index, 'value')}
                                                placeholder={`Price ${index + 1}`}
                                                aria-label={`Price ${index + 1}`}
                                            />
                                            <Button variant="danger" onClick={() => handleRemoveField(index)} >
                                                <i class="bi bi-x-circle-fill"></i>
                                            </Button>
                                        </div>

                                    </div>
                                ))}
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className='buttonDesign' onClick={() => setModalShow(false)}>Close</button>
                            <button className='buttonDesign' onClick={() => handleAddingRoomMaterial()}>Update Item</button>
                        </Modal.Footer>
                    </Modal>

                    {/* Edit Item Modal */}
                    <Modal show={itemShow} size="lg" centered>
                        <Modal.Header closeButton onClick={() => setItemShow(false)}>
                            <Modal.Title>Edit Item</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h4>Edit Item Details</h4>
                            <p>Modify the material name and price as needed.</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => setItemShow(false)}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>

            <hr />
            <div className="itemmaping">
                {roomDatasets.map((item, index) => (
                    <div key={index}>
                        <div>
                            <div className="nameEdit">
                                <h6>{item.name}</h6>
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: 12,
                                }}>
                                    <button onClick={() => handelmodel(item)} className="buttonDesign">
                                        Edit
                                    </button>
                                    <button onClick={() => handelDeleteModel(item)} className="buttonDesign">
                                        Delete
                                    </button>
                                </div>
                            </div>
                            <div className="materialitem">
                                {item.material.map((item2, idx) => (
                                    <div key={idx}>
                                        <p>{item2.label}</p>
                                        {pricemode === "oldvalue" ? (
                                            <p className="materialitem1">{item2.oldvalue || 0}</p>
                                        ) : (
                                            <p className="materialitem1">{item2.value || 0}</p>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <hr />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AdminPriceRoom;
